<template>
  <div class="form">
    <div v-if="status=='0' && user" class="body-right-set-form">
      <div class="body-right-set-form-padding">
        <div class="body-right-set-form-item flex-row-align-center">
          <div class="body-right-set-form-item-key flex-row-align-center">
            <p class="font-size-14 font-color-1F233E font-bold">用户ID</p>
          </div>
          <div class="body-right-set-form-item-value input-disabel flex-row-align-center">
            <p class="font-color-7B84A1 font-size-12">{{ user.userId }}</p>
          </div>
        </div>

        <div class="body-right-set-form-item flex-row-align-center">
          <div class="body-right-set-form-item-key flex-row-align-center">
            <p class="font-size-14 font-color-1F233E font-bold">绑定团体</p>
          </div>
          <div class="body-right-set-form-item-value input-disabel flex-row-align-center">
            <p class="font-color-7B84A1 font-size-12">{{ user.teamName }}</p>
          </div>
        </div>

        <div class="body-right-set-form-item flex-row-align-center">
          <div class="body-right-set-form-item-key flex-row-align-center">
            <p class="font-size-14 font-color-1F233E font-bold">账号有效期至</p>
          </div>
          <div class="body-right-set-form-item-value input-disabel flex-row-align-center">
            <p class="font-color-7B84A1 font-size-12">{{ user.effectiveDate }}</p>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="status == '1' && user" class="body-right-set-form">
      <div class="body-right-set-form-padding">
        <div class="body-right-set-form-item flex">
          <div class="body-right-set-form-item-key flex-row-align-center">
            <p class="font-size-14 font-color-1F233E font-bold">头像</p>
          </div>
          <div class="body-right-set-form-item-value-cropper">
            <cropper ref="cropperimg" @success="uploadSuccess" />
          </div>
        </div>
      </div>
      <div class="body-right-set-action mach-width flex-center">
        <div class="body-right-set-action-btns flex-row-align-center">
          <div class="flex-center body-right-set-action-btns-save radius-clip-5 bg-282B80 cursor" @click="requestSave">
            <p class="font-size-14 font-color-white">保存</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import cropper from './cropperImage.vue'
import api from '../../../../../api/userpage.js'
import userdata from '../../../../../models/user.js'

export default {
  components: {
    cropper
  },
  props: {
    status: {
      type: String,
      default: '0',
      required: true
    }
  },
  data() {
    return {
      user: null
    }
  },
  created() {
    this.request()
  },
  methods: {
    request() {
      const that = this
      api.teamuserInfo().then(result => {
        that.user = result.data
      }).catch((error) => {
        that.$message({
          showClose: false,
          message: error.message,
          type: 'error'
        })
      })
    },
    requestSave() {
      this.$refs.cropperimg.uploadImg()
    },
    uploadSuccess(v) {
      const userData = userdata.getUserData()
      const params = {
        id: userData.team.id,
        teamAvatar: v.data
      }
      const that = this

      api.teamuserUpdate(params).then(r => {
        userData.team.teamAvatar = v.data
        userdata.updateUser()
        that.$message({
          showClose: false,
          message: '头像保存成功',
          type: 'success'
        })
        that.$emit('update')
      }).catch(() => {
        that.$message({
          showClose: false,
          message: '头像保存失败',
          type: 'error'
        })
      })
    }
  }
}
</script>
<style src="@/styles/pc.css" scoped>
</style>
<style lang="scss" scoped>
::v-deep .el-input__inner {
  font-size: 12px !important;
    color: #264480 !important;
    padding: 0 !important;
    border: none !important;
}
::v-deep .el-input__suffix-inner {
  display: none;
}
::v-deep .el-date-editor.el-input, .el-date-editor.el-input__inner {
  width: 100% !important;
}
::v-deep .el-input__prefix {
  left: 0;
}
::v-deep .el-input__icon {
  width: initial !important;
}

/deep/ .el-select-dropdown__item.selected {
  color: #264480 !important;
}

.date {
  ::v-deep .el-input__inner {
     padding-left: 24px !important;
  }
}

</style>
<style scoped>

.body-right-set-tip {
  background-color: #FFFAEF;
  height: 40px;
  margin-top: 20px;
  padding: 0 20px;

}

.body-right-set-tip p {
  color: #B29453;
}

.body-right-set-tip p:last-child {
  padding: 6px;
}

.body-right-set-form {
  margin-top: 20px;
  border: 1px solid #F3F4F9;
}

.body-right-set-form-item {
  margin-bottom: 30px;
}

.body-right-set-form-item:last-child {
  margin: 0;
}

.body-right-set-form-item-key {
  justify-content: flex-end;
  width: 134px;
  height: 40px;
  padding-right: 16px;
}

.body-right-set-form-item-value {
  width: 340px;
  height: 40px;
  padding: 0 14px;
  border: 1px solid #DEE0E7;
  overflow: hidden;
}

.body-right-set-form-item-btn {
  width: 82px;
  height: 40px;
}

.body-right-set-form-item-value input {
  border: none;
  width: 100%;
}

.body-right-set-form-item-key-must {
  margin-right: 4px;
}

.body-right-set-form-item-value input:focus {
  outline: none;
}

 .body-right-set-form-item-value input::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #DEE0E7;
  }
  .body-right-set-form-item-value input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #DEE0E7;
  }
  .body-right-set-form-item-value input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #DEE0E7;
  }
  .body-right-set-form-item-valueinput:-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: #26272b;
  }

  .body-right-set-form-item-valueinput:focus {
    outline: none;
  }

  .body-right-set-form-item .input-disabel {
    background-color: #E9E9F3;;
  }

  .body-right-set-form-item-des {
    height: 40px;
    margin-left: 10px;
  }

  .body-right-set-action {
    height: 126px;
  }

  .body-right-set-action-btns-cancel{
    width: 82px;
    height: 30px;
    background-color: #F3F4F9;
  }

  .body-right-set-action-btns-save {
    width: 82px;
    height: 30px;
    margin-left: 36px;
  }

  .input-date-hidden {
    width: 100%;
    height: 80%;
    left: 0;
    right: 0;
    z-index: 9;
    opacity: 0;
  }
  .body-right-set-form-item-value-cropper {
    width: 100%;
    margin-left: 8px;
  }

  .body-right-set-form-padding {
    padding: 48px 0;
    border-bottom: 1px solid #F3F4F9;
  }

</style>
